(function() {
    'use strict';

    angular.module('app.devengados', []);
})();
